"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _IndividualDetailReview_personalDetails_accessor_storage, _IndividualDetailReview_physicalCharacteristics_accessor_storage, _IndividualDetailReview_contactInformation_accessor_storage, _IndividualDetailReview_identification_accessor_storage;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndividualDetailReview = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const individual_details_util_1 = require("@app/util/individual-details-util");
const individual_details_styles_1 = require("./individual-details-styles");
const date_util_1 = require("@app/util/date-util");
let IndividualDetailReview = class IndividualDetailReview extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        _IndividualDetailReview_personalDetails_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPersonalInformation());
        _IndividualDetailReview_physicalCharacteristics_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyPhysicalCharacteristics());
        _IndividualDetailReview_contactInformation_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyContactInformation());
        _IndividualDetailReview_identification_accessor_storage.set(this, individual_details_util_1.IndividualDetailsUtil.getEmptyIdentification());
    }
    get personalDetails() { return __classPrivateFieldGet(this, _IndividualDetailReview_personalDetails_accessor_storage, "f"); }
    set personalDetails(value) { __classPrivateFieldSet(this, _IndividualDetailReview_personalDetails_accessor_storage, value, "f"); }
    get physicalCharacteristics() { return __classPrivateFieldGet(this, _IndividualDetailReview_physicalCharacteristics_accessor_storage, "f"); }
    set physicalCharacteristics(value) { __classPrivateFieldSet(this, _IndividualDetailReview_physicalCharacteristics_accessor_storage, value, "f"); }
    get contactInformation() { return __classPrivateFieldGet(this, _IndividualDetailReview_contactInformation_accessor_storage, "f"); }
    set contactInformation(value) { __classPrivateFieldSet(this, _IndividualDetailReview_contactInformation_accessor_storage, value, "f"); }
    get identification() { return __classPrivateFieldGet(this, _IndividualDetailReview_identification_accessor_storage, "f"); }
    set identification(value) { __classPrivateFieldSet(this, _IndividualDetailReview_identification_accessor_storage, value, "f"); }
    render() {
        return (0, lit_1.html) `
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">PERSONAL INFORMATION</forge-label>
      </div>
      <div class="detail-content-review-container">
        <forge-label-value>
          <forge-label slot="label">First Name</forge-label>
          <forge-label slot="value">${this.personalDetails.firstName}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Middle Name</forge-label>
          <forge-label slot="value">${this.personalDetails.middleName}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Last Name</forge-label>
          <forge-label slot="value">${this.personalDetails.lastName}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">DOB</forge-label>
          <forge-label slot="value">${date_util_1.DateUtil.fixDateOfBirth(this.personalDetails.birthDate)}</forge-label>
        </forge-label-value>
      </div>
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">DEMOGRAPHICS</forge-label>
      </div>
      <div class="detail-content-review-container">
        <forge-label-value>
          <forge-label slot="label">Gender</forge-label>
          <forge-label slot="value">${this.personalDetails.gender}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Ethnicity</forge-label>
          <forge-label slot="value">${this.personalDetails.ethnicity}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Race</forge-label>
          <forge-label slot="value">${this.personalDetails.race}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Height</forge-label>
          <forge-label slot="value">${this.physicalCharacteristics.height}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Weight</forge-label>
          <forge-label slot="value">${this.physicalCharacteristics.weight}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Eye Color</forge-label>
          <forge-label slot="value">${this.physicalCharacteristics.eyeColor}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Hair Color</forge-label>
          <forge-label slot="value">${this.physicalCharacteristics.hairColor}</forge-label>
        </forge-label-value>
      </div>
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">CONTACT INFORMATION</forge-label>
      </div>
      <div class="detail-content-review-container">
        <forge-label-value>
          <forge-label slot="label">Phone Number</forge-label>
          <forge-label slot="value">${this.contactInformation.phoneNumber}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Residence Address</forge-label>
          <forge-label slot="value">
            ${this.contactInformation.address2
            ? `${this.contactInformation.address} ${this.contactInformation.address2}, ${this.contactInformation.city}, ${this.contactInformation.state} ${this.contactInformation.zip}`
            : `${this.contactInformation.address}, ${this.contactInformation.city}, ${this.contactInformation.state} ${this.contactInformation.zip}`}
          </forge-label>
        </forge-label-value>
      </div>
      <div class="forge-card-header-container">
        <forge-label class="card-subtitle">IDENTIFICATIONS</forge-label>
      </div>
      <div class="detail-content-review-container">
        <forge-label-value>
          <forge-label slot="label">Social Security Number</forge-label>
          <forge-label slot="value">${individual_details_util_1.IndividualDetailsUtil.getFormatSnn(this.identification.ssn)}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">SID Number</forge-label>
          <forge-label slot="value">${this.identification.sidNumber}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">Drivers License</forge-label>
          <forge-label slot="value">${this.identification.dlNumber}</forge-label>
        </forge-label-value>
        <forge-label-value>
          <forge-label slot="label">FBI Number</forge-label>
          <forge-label slot="value">${this.identification.fbiNumber}</forge-label>
        </forge-label-value>
      </div>
    `;
    }
};
exports.IndividualDetailReview = IndividualDetailReview;
_IndividualDetailReview_personalDetails_accessor_storage = new WeakMap();
_IndividualDetailReview_physicalCharacteristics_accessor_storage = new WeakMap();
_IndividualDetailReview_contactInformation_accessor_storage = new WeakMap();
_IndividualDetailReview_identification_accessor_storage = new WeakMap();
Object.defineProperty(IndividualDetailReview, "styles", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: [individual_details_styles_1.individualDetailStyles]
});
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailReview.prototype, "personalDetails", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailReview.prototype, "physicalCharacteristics", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailReview.prototype, "contactInformation", null);
__decorate([
    (0, decorators_js_1.property)({ type: Object })
], IndividualDetailReview.prototype, "identification", null);
exports.IndividualDetailReview = IndividualDetailReview = __decorate([
    (0, decorators_js_1.customElement)('sup-individual-detail-review')
], IndividualDetailReview);
